<template>
  <div
    v-if="rows.length > 0"
  >
    <b-card title="Listado de agendas">
      <b-button
        class="ml-2 float-right"
        variant="primary"
        type="submit"
        :to="{ name: 'admin-create-users'}"
      >
        Crear usuario
      </b-button>

      <!-- search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Buscar</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Buscar"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </div>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >

          <!-- Column: Name -->
          <span
            v-if="props.column.field === 'fullName'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.first_name }}</span>
          </span>

          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'document_number'">
            {{ props.row.document_number }}
          </span>

          <span v-else-if="props.column.field === 'role'">
            <b-badge :variant="statusVariant(props.row.role.name)">
              {{ props.row.role.name }}
            </b-badge>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>

              <b-button
                v-b-tooltip.hover.top="'Ver detalle'"
                variant="flat-primary"
                class="btn-icon"
                title="Detalle"
                :to="{name: 'admin-detail-users', params: { id: props.row.id } }"
              >
                <feather-icon
                  icon="EyeIcon"
                  class="text-success"
                  size="18"
                />
              </b-button>

              <b-button
                v-b-tooltip.hover.top="'Ver detalle'"
                variant="flat-danger"
                class="btn-icon"
                title="Eliminar"
                :disabled="loading"
                @click="openDeleteModal(props.row.id)"
              >
                <feather-icon
                  icon="TrashIcon"
                  class="text-danger"
                  size="18"
                />
              </b-button>

              <!--              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  :to="{name: 'admin-detail-users', params: { id: props.row.id } }"
                >
                  <feather-icon
                    icon="EyeIcon"
                    class="mr-50"
                  />
                  <span>Detalle</span>
                </b-dropdown-item>
                <b-dropdown-item>
                  <feather-icon
                    icon="TrashIcon"
                    class="mr-50"
                  />
                  <span>Delete</span>
                </b-dropdown-item>
              </b-dropdown>-->
            </span>
          </span>

          <!-- Column: Created at -->
          <span v-else-if="props.column.field === 'created_at'">
            {{ formatDateVariant(props.row.created_at) }}
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Mostrando 1 a
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['10','20','50']"
                class="mx-1"
                @input="(value)=>props.perPageChanged({currentPerPage:value})"
              />
              <span class="text-nowrap"> de {{ props.total }} items </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value)=>props.pageChanged({currentPage:value})"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

    </b-card>

    <b-modal
      ref="deleteModal"
      title="Confirmar eliminación"
      size="md"
      hide-footer
      :no-close-on-backdrop="loading"
      :no-close-on-esc="loading"
    >
      <div
        v-if="loading"
        class="text-center py-3"
      >
        <b-spinner label="Eliminando..." />
        <p class="mt-2">
          Eliminando usuario...
        </p>
      </div>
      <div v-else>
        <p>¿Estás seguro de que deseas eliminar este usuario? Esta acción no se puede deshacer.</p>

        <div class="d-flex justify-content-end mt-3">
          <b-button
            variant="secondary"
            @click="$refs.deleteModal.hide()"
          >
            Cancelar
          </b-button>
          <b-button
            variant="danger"
            class="ml-2"
            @click="deleteUser"
          >
            Eliminar
          </b-button>
        </div>
      </div>
    </b-modal>

  </div>

  <loading-skeleton v-else />

</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BCard,
  BSpinner,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store'
import api from '@/plugin/axios'
import { formatDate } from '@/helpers/utils'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'

export default {
  components: {
    LoadingSkeleton,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'ID',
          field: 'id',
        },
        {
          label: 'Nombre',
          field: 'first_name',
        },
        {
          label: 'Perfil',
          field: 'role',
        },
        {
          label: 'Documento',
          field: 'document_number',
        },
        {
          label: 'Celular',
          field: 'phone',
        },
        {
          label: 'Correo electrónico',
          field: 'email',
        },
        {
          label: 'Fecha de creación',
          field: 'created_at',
        },
        {
          label: 'Acciones',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
      status: [{
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      {
        1: 'light-primary',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-warning',
        5: 'light-info',
      }],
      userToDeleteId: null,
      loading: false,
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Admin      : 'light-primary',
        Comercial : 'light-success',
        Planificador     : 'light-danger',
        Técnico     : 'light-warning',
        Odontólogo      : 'light-info',
        Clínica      : 'light-secondary',
        Paciente      : 'light-danger',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    formatDateVariant() {
      return date => formatDate(date)
    },
  },
  async created() {
    const [rows] = await Promise.all([
      api.get('/api/users'),
    ])

    this.rows = rows.data
    console.log(this.rows)
  },
  methods: {
    async getUsers() {
      const [rows] = await Promise.all([
        api.get('/api/users'),
      ])

      this.rows = rows.data
    },
    openDeleteModal(userId) {
      this.userToDeleteId = userId
      this.$refs.deleteModal.show()
    },
    async deleteUser() {
      this.loading = true
      try {
        // Aquí llamas a tu API o servicio para eliminar
        await api.delete(`/api/users/${this.userToDeleteId}`)
        this.$toast.success('Usuario eliminado correctamente')
        this.getUsers()
        // Aquí puedes recargar la lista o hacer otra acción
      } catch (error) {
        this.$toast.error('Error al eliminar el usuario')
      } finally {
        this.$refs.deleteModal.hide()
        this.loading = false
      }
    },
  },
}
</script>
